module.exports = __webpack_public_path__ + "img/euFond1.6b58949d.jpg";